import { render, staticRenderFns } from "./EditorContent.vue?vue&type=template&id=0243c1e4&scoped=true&"
import script from "./EditorContent.vue?vue&type=script&lang=js&"
export * from "./EditorContent.vue?vue&type=script&lang=js&"
import style0 from "./EditorContent.vue?vue&type=style&index=0&id=0243c1e4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243c1e4",
  null
  
)

export default component.exports